var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvcVideoIconBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #73b9ff;\n      }\n\n      .cls-2, .cls-5 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #e0e0e0;\n        stroke-linecap: round;\n        stroke-dasharray: 5 5;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914",
    transform: "translate(0.193 0.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2111",
    "data-name": "Group 2111",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39368",
    "data-name": "Ellipse 39368",
    className: "cls-1",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    transform: "translate(3.807 3.93)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_39369",
    "data-name": "Ellipse 39369",
    className: "cls-2",
    transform: "translate(-0.193 -0.07)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 33.5,
    cy: 33.5,
    r: 33.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 33.5,
    cy: 33.5,
    r: 33
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-video-call",
    className: "cls-3",
    d: "M7.8,9A3.815,3.815,0,0,0,4,12.8v9.941a3.815,3.815,0,0,0,3.8,3.8h9.941a3.815,3.815,0,0,0,3.8-3.8v-.789l4.52,2.711a.877.877,0,0,0,1.328-.753V11.632a.877.877,0,0,0-1.328-.753l-4.52,2.711V12.8a3.815,3.815,0,0,0-3.8-3.8Zm0,1.754h9.941A2.034,2.034,0,0,1,19.789,12.8v9.941a2.034,2.034,0,0,1-2.047,2.047H7.8a2.034,2.034,0,0,1-2.047-2.047V12.8A2.034,2.034,0,0,1,7.8,10.754Zm17.836,2.427v9.181l-4.093-2.456V15.637Z",
    transform: "translate(17.57 15.496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvcVideoIconBorder);
export default __webpack_public_path__ + "static/media/avc_video_icon_border.ecd1624757604769150b006d360b7030.svg";
export { ForwardRef as ReactComponent };